// 导入组件
import Vue from 'vue';

import Router from 'vue-router';


export default new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      name: '',
      component: () => import('@/views/index'),
      hidden: true,
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/login',
      name: '登录',
      component: () => import('@/views/login'),
      hidden: true,
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/home',
      name: '首页',
      component: () => import('@/views/home/home'),
      meta: {
        requireAuth: true,
      }
    },
    {
      path: '/project',
      name: '业务管理',
      component: () => import('@/views/index'),
      iconCls: 'el-icon-tickets',
      children: [

        {
          path: '/project/home',
          name: '项目列表',
          component: () => import('@/views/home/home'),
          meta: {
            requireAuth: true,
            activeMenu: '/project/home'
          }
        },
        {
          path: '/project/list',
          name: '项目列表',
          component: () => import('@/views/project/list'),
          meta: {
            requireAuth: true,
            activeMenu: '/project/list'
          }
        },
        {
          path: '/project/map',
          name: '地图',
          component: () => import('@/views/project/map'),
          meta: {
            requireAuth: true,
            activeMenu: '/project/map'
          }
        },
        {
          path:'/project/log',
          name:'日志',
          component:()=>import('@/views/system/log/log'),
          meta:{
            requireAuth:true
          }
        },
        {
          path:'/project/operationlog',
          name:'班组日志',
          component:()=>import('@/views/operationLog/operationLog.vue'),
          meta:{
            requireAuth:true
          }
        },
        {
          path:'/project/teams',
          name:'班组列表',
          component:()=>import('@/views/teams'),
          meta:{
            requireAuth:true
          }
        }
      ]

    },
    {
      path: '/system',
      name: '用户',
      component: () => import('@/views/index'),
      iconCls: 'el-icon-tickets',
      children: [
        {
          path: '/system/disposition',
          name: '配置管理',
          component: () => import('@/views/system/disposition/disposition'),
          meta: {
            requireAuth: true,
            activeMenu: '/system/disposition'
          }
        },
        {
          path: '/system/userList',
          name: '用户管理',
          component: () => import('@/views/user/userList/userList'),
          meta: {
            requireAuth: true,
            activeMenu: '/system/userList'
          }
        }
      ]
    },

  ]
})
Vue.use(Router);



// WEBPACK FOOTER //
// ./src/router/index.js